//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class FileAccessTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[FileAccessType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/asset/file-access-type/detail', {'params':params});
	};

	//GeneratorFlag:[FileAccessType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/asset/file-access-type/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}